module.exports = __webpack_public_path__ + "static/media/400385_01.eb918582.png";